import { useState, useEffect } from "react";

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
};

export const useIsMobileWidth = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === document.documentElement) {
          setIsMobile(entry.contentRect.width < 768);
        }
      }
    });

    resizeObserver.observe(document.documentElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return isMobile;
};

export const useIsTabletWidth = () => {
  const [isTabletOrMobile, setIsTabletOrMobile] = useState(
    window.innerWidth < 1076,
  );

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === document.documentElement) {
          setIsTabletOrMobile(entry.contentRect.width < 1076);
        }
      }
    });

    resizeObserver.observe(document.documentElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return isTabletOrMobile;
};

/** Is it wide enough for NavMenu2026 ("Floats" on the left outside of the main containers) */
export const useIsWideDesktopWidth = () => {
  const [isWideDesktop, setIsWideDesktop] = useState(window.innerWidth >= 1450);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === document.documentElement) {
          setIsWideDesktop(entry.contentRect.width >= 1450);
        }
      }
    });

    resizeObserver.observe(document.documentElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return isWideDesktop;
};
